// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2z8qw","content":"styles_content__3fQL6","row":"styles_row__3Hf7z","footer":"styles_footer__2aF2l","phraseLength":"styles_phraseLength__2XxSZ"};